﻿// Import axios for API consuming in a clean interface.
import axios from 'axios';

// Import general mixin for shared functionality.
import mixin from './mixin';

// Import filters
import FilterDossierId from './components/caseSearch/filters/DossierId.vue';
import FilterDebtorName from './components/caseSearch/filters/DebtorName.vue';
import FilterClientNameId from './components/caseSearch/filters/ClientNameId.vue';
import FilterCreditorNameId from './components/caseSearch/filters/CreditorNameId.vue';
import FilterStatus from './components/caseSearch/filters/Status.vue';
import FilterStatusExternal from './components/caseSearch/filters/StatusExternal.vue';
//import FilterDate from './components/caseSearch/filters/Date.vue';
import FilterReference from './components/caseSearch/filters/Reference.vue';
import FilterSettlingReason from './components/caseSearch/filters/SettlingReason.vue';

// Import table component
import TableCaseSearch from './components/caseSearch/Table.vue';

const caseSearchApp = {
    mixins: [mixin],
    components: {
        FilterDossierId,
        FilterDebtorName,
        FilterClientNameId,
        FilterCreditorNameId,
        FilterStatus,
        FilterStatusExternal,
        //FilterDate,
        FilterReference,
        FilterSettlingReason,
        TableCaseSearch,
    },
    data() {
        return {
            dataUrlApi: '/api/dossiers/findbysearchterm/',
            dataUrlDossierdetail: '/dossierdetail/',
            loading: false,
            dossiers: [],
            filters: [],
            resetCount: 0,
        }
    },
    computed: {
        columns() {
            return [
                {
                    label: this.$store.getters.getText('casesearchTableDossierid'),
                    field: 'dossier_nr',
                    type: 'link',
                    url: this.dataUrlDossierdetail,
                },
                {
                    label: this.$store.getters.getText('casesearchTableDebtorname'),
                    field: 'debiteur_naam',
                },
                {
                    label: this.$store.getters.getText('casesearchTableClientnameid'),
                    field: 'opdrachtgever_portal_relatie_nr',
                    secondField: 'opdrachtgever_portal_naam',
                    type: 'combination',
                },
                {
                    label: this.$store.getters.getText('casesearchTableCreditornameid'),
                    field: 'eiser_portal_relatie_nr',
                    secondField: 'eiser_portal_naam',
                    type: 'combination',
                },
                {
                    label: this.$store.getters.getText('casesearchTableClosed'),
                    field: 'lopend_afgesloten',
                    type: 'boolean',
                },
                {
                    label: this.$store.getters.getText('casesearchTableStatus'),
                    field: 'status_extern_label',
                },
                {
                    label: this.$store.getters.getText('casesearchTableDate'),
                    field: 'ingangsdatum',
                    type: 'date',
                },
                {
                    label: this.$store.getters.getText('casesearchTableReference'),
                    field: 'referentie_nr',
                },
                {
                    label: this.$store.getters.getText('casesearchTableSettlingreason'),
                    field: 'afsluitreden_groep_label',
                },
            ];
        },
        computedDossiers() {
            return this.dossiers;
        },
        filteredDossiers() {
            if (!this.filters.length) return this.computedDossiers;
            return this.filterDossiers(this.computedDossiers, this.filters);
        },
        activeFilters() {
            return this.filters;
        },
        filtersActive() {
            return this.filters.length;
        },
    },
    async mounted() {
        if (this.$el.dataset.urlApi) this.dataUrlApi = this.$el.dataset.urlApi;
        if (this.$el.dataset.urlDossierdetail) this.dataUrlDossierdetail = this.$el.dataset.urlDossierdetail;
        this.loading = true;
        const urlParams = new URLSearchParams(window.location.search);
        const searchQuery = urlParams.get('q');
        if (searchQuery) {
            await this.fetchData(searchQuery);
        }
        else {
            this.loading = false;
        }
    },
    methods: {
        async fetchData(searchQuery) {
            let offset = 0;
            const limit = 25000;
            const dossiersArray = [];

            try {
                const response = await axios.post(
                    this.dataUrlApi,
                    {
                        Limit: limit,
                        Offset: offset,
                        Text: searchQuery,
                    }
                );
                if (!response || response.status != 200 || !response.data) throw 'no response or bad status';
                dossiersArray.push(...response.data.items.map(dossier => {
                    return {
                        ...dossier,
                        dossier_nr: this.parseDossierNr(dossier.dossier_nr),
                    }
                }));

                if (response.data.queryCount > limit) {
                    const remainingCalls = Math.floor(response.data.queryCount / limit);

                    const promises = [];

                    for (let i = 1; i <= remainingCalls; i++) {
                        offset = i * limit;
                        promises[i - 1] = axios.post(
                            this.dataUrlApi,
                            {
                                Limit: limit,
                                Offset: offset,
                                Text: searchQuery,
                            }
                        );
                    }

                    const responses = await Promise.all(promises);

                    responses.forEach(response => {
                        if (response.status === 200 && response.data && response.data.items) {
                            dossiersArray.push(...response.data.items.map(dossier => {
                                return {
                                    ...dossier,
                                    dossier_nr: this.parseDossierNr(dossier.dossier_nr),
                                }
                            }));
                        } else {
                            throw 'No response or bad status';
                        }
                    });
                }

                this.dossiers = dossiersArray;
            } catch (error) {
                console.error('Error loading JSON data: ', error);
            }
            this.loading = false;
        },
        onFilter(payload) {
            if (!payload) return;
            this.filters = this.filters.filter(filter => filter.type !== payload.type);
            if (typeof payload.value === 'number' || typeof payload.value === 'string') {
                if (payload.value) this.filters.push(payload);
            }
            else {
                if (payload.value.length) this.filters.push(payload);
            }
        },
        resetFilters() {
            this.filters = [];
            this.resetCount++;
        },
    },
}

export default caseSearchApp;
